import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Network from '../utils/Network'
import { setUserInfo } from '../redux/user/action'
import { is } from '@react-three/fiber/dist/declarations/src/core/utils'
import useAuth from './useAuth'

type Props = {}

const useUserData = () => {

    const userInfo = useSelector((state: any) => state?.userInfo)
    const userToken = useSelector((state: any) => state?.userToken)
    const axios = new Network()
    const dispatch = useDispatch();
    const isCalled = useRef(false)
    const { handleLogout} =useAuth()

    const getUserData = async () => {
        const response = await axios.CallApi({
            url: "/player",
            method: "get",
        });
        if (response.ok) {
            dispatch(setUserInfo(response.data));
        }
    }
    useEffect(() => {
        if (!userToken) {
            handleLogout();
        }
    }, [])
    useEffect(() => {
        if (isCalled.current) return
        isCalled.current = true
        getUserData();
    }, [userInfo])

    return (
        {
            userInfo,
            getUserData
        }
    )
}

export default useUserData